import { useCurrentUser, useView } from '@/hooks';
import { Button, Typography } from '@/ui';

import Today from './Today';

import { isCoach } from '@/types/user';

const Session = () => {
  const { user } = useCurrentUser();
  const { isClient } = useView();

  if (isClient || !isCoach(user)) return null;

  return (
    <>
      <div className="flex items-center justify-between ">
        <Typography className="mb-4 mt-6 text-white" variant="h5">
          Next session, today
        </Typography>
        <Button
          color="white"
          href="/coach/sessions/upcoming"
          size="small"
          variant="outlined"
        >
          See all sessions
        </Button>
      </div>
      <Today />
      <div className="h-5" />
    </>
  );
};

export default Session;
